import React from 'react'
import das from './dash.module.css'
import { MdOutlineDashboard } from 'react-icons/md'
import { LuFileSliders } from 'react-icons/lu'
import { CiSettings } from 'react-icons/ci'
import imgi from '../../../img/newimage/1.png'
import imgii from '../../../img/newimage/2.png'
import imgiii from '../../../img/newimage/3.png'
import imgiv from '../../../img/newimage/4.png'
import imgv  from '../../../img/newimage/5.png'
import imgvi from '../../../img/newimage/6.png'
import imgvii from '../../../img/newimage/7.png'
import imgviii from '../../../img/newimage/8.png'
import imgI from '../../../img/new/7.png'
import imgII from '../../../img/new/8.png'
import imgIII from '../../../img/new/6.png'
import imgIV from '../../../img/logo 1.png'
import { FaUnlink } from 'react-icons/fa'
import { Link } from 'react-router'
const AdminDash = () => {
    let date = new Date();

let n = date.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
});


  return (
    <div className={das.das}>
        <div className={das.container}>
                 <div className={das.contentI}>
                    <img src={imgIV} className={das.img} alt="" />
                    <img src={imgIII} className={das.img} alt="" />
                </div>
            <div className={das.content}>
           
                <div className={das.block}>
                    <div className={das.blocki}>
                         <div className={das.seci}>
                            <div className={das.icon}>
                                <MdOutlineDashboard className={das.word}/>
                                <h3 className={das.word}>Dashboard</h3>
                            </div>
                            <Link to='/Admin/AdminBoard/AdminEmploy'>
                            <div className={das.icon}>
                                <LuFileSliders />
                                <h3>Employees</h3>
                            </div>
                            </Link  >
                            <Link to='/Admin/AdminBoard/AccessCode'>
                            <div className={das.icon}>
                                <LuFileSliders />
                                <h3>Access Code</h3>
                            </div>
                            </Link>
                        </div>
                        <div className={das.seciI}>
                            <div className={das.icon}>
                                <CiSettings />
                                <h3>Settings</h3>
                            </div>
                            <Link to='/Admin'>
                            <div className={das.icon}>                               
                                <h3>Logout</h3>
                            </div>
                            </Link>
                        </div>
                    </div>
                    <div className={das.blockI}>
                        <div className={das.blockII}>
                            <div className={das.flex}>
                                <div className={das.flexi}>
                                    <h4>Partnership</h4>
                                    <p>
                                        Manage and control partnership, see the companies , brands 
                                        that has a partnership role with your company. Modify your
                                        partnership with brands and other organisations
                                    </p>
                                    <div className={das.grid}>
                                        <img src={imgi} alt="" />
                                        <img src={imgii} alt="" />
                                        <img src={imgiii} alt="" />
                                        <img src={imgiv} alt="" />
                                        <img src={imgv} alt="" />
                                        <img src={imgvi} alt="" />
                                        <img src={imgvii} alt="" />
                                        <img src={imgviii} alt="" />
                                    </div>
                                </div>
                                <div className={das.flexii}>
                                    <h4>Metrics</h4>
                                    <p>Analysis your blog data , check and control the  data of your overall activities 
                                    carried out on your blog site.</p>
                                    <div className={das.gridi}>
                                        <div className={das.card}>
                                            <h6>348</h6>
                                            <p>Uploaded Articles</p>
                                        </div>
                                        <div className={das.card}>
                                            <h6>48</h6>
                                            <p>Members</p>
                                        </div>
                                        <div className={das.card}>
                                            <h6>60</h6>
                                            <p>Partnership</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={das.block2}>
                            <div className={das.flexI}>
                                <h4>Schedule Meeting</h4>
                                <p>Schedule meeting with your employees, share an invite link and send 
                                directly to their mail with a click.</p>
                                <h5><FaUnlink /> Meeting link </h5>
                                <input type="text" />
                                <p>Paste the copied link from zoom. whatsapp, Skype or any other social 
                                conference platform here and share it with your employees</p>
                                <h5>Employees</h5>
                                <input type="text" placeholder='Enter employee’s mail' />
                                <h6>Quick search</h6>
                                <div className={das.boxes}>
                                    <img src={imgI} alt="" />
                                    <img src={imgII} alt="" />
                                    <img src={imgIII} alt="" />
                                </div>
                            </div>
                            <div className={das.flexII}>
                                <h4>Conversation</h4>
                                <p>Information can be shared via chat, members received message via their mail and any form of 
                                message such as link to meeting or general message are sent to their mail.</p>
                                <div className={das.secIV}>
                                    <div className={das.secV}>
                                        <div className={das.secVI}>
                                            <img src={imgI} alt="" />
                                            <div className={das.link}>
                                                <p>Funmilayo234@gmail.com</p>
                                                <span>See the link to the meeting attached to the msg sent to you</span>
                                            </div>

                                        </div>
                                        <h4>{n}</h4>
                                    </div>                                  
                                    
                                </div>
                                <Link><button>Send a message</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AdminDash
